import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import heartIconRed from 'assets/img/icons/heart.svg';
import heartIconGrey from 'assets/img/icons/heart-grey.svg';

import {
  ProText,
  InfoBox,
  HeartIcon,
  InfoText,
} from '../styles.js';

const FavoriteCard = ({ taskQuoteProDetail }) => (
  <InfoBox>
    <HeartIcon favorite={taskQuoteProDetail.has_been_hired}>
      <img src={taskQuoteProDetail.has_been_hired ? heartIconRed : heartIconGrey} alt="Heart Icon" />
    </HeartIcon>
    {taskQuoteProDetail.has_been_hired ? (
      <Fragment>
        <InfoText>Profissional favoritado</InfoText>
        <ProText>
          Esse profissional já foi contratado várias vezes pela sua empresa e é bem avaliado!
        </ProText>
      </Fragment>
    ) : (
      <Fragment>
        <InfoText>NUNCA CONTRATADO PELA EMPRESA</InfoText>
        <ProText>
          Dê uma olhada nas avaliações e converse com esse profissional!
        </ProText>
      </Fragment>
    )}
  </InfoBox>
);

const mapStateToProps = state => ({
  taskQuoteProDetail: state.task.taskQuoteProDetail,
});

export default connect(
  mapStateToProps,
)(FavoriteCard);
